import { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

export interface Announcement {
  message: string;
  link: string;
  linkText: string;
  isActive: boolean;
}

const EMPTY: Announcement = { message: '', link: '', linkText: '', isActive: false };

/** Fetches the admin-editable site-wide announcement banner. isActive: false (the
 *  default while loading/on failure) means "don't show a banner". */
export function useAnnouncement(): Announcement {
  const [announcement, setAnnouncement] = useState<Announcement>(EMPTY);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/journal/announcement`)
      .then((res) => setAnnouncement({ ...EMPTY, ...res.data }))
      .catch(() => setAnnouncement(EMPTY));
  }, []);

  return announcement;
}

export default useAnnouncement;
